import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'

import { getClassName, link } from '../../../../cms/blocks/utils.gen'
import { TemplateState } from '../../../../cms/page/types.gen'
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.gen'
import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { CustomBlockData } from '../types.mod'

export type BSLCountersBlockProps = {
  items: BSLCounterProps[]
}

export type BSLCounterProps = {
  key?: string
  title: string
  subtitle: string
}

export type BSLCountersBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  container_classname: string
  item_classname: string
  item_title_classname: string
  item_subtitle_classname: string
}>

export function BSLCountersBlock<customBlockData, extra_images>(
  props: BSLCountersBlockProps,
  options?: { style?: BSLCountersBlockStyle; key?: string }
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>>
> {
  return (s: TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => (
        <>
          <section
            className={getClassName(options, 'block_classname', 'block')}
            key={options && options.key ? options.key : ''}
          >
            <div className={getClassName(options, 'inner_classname', 'block__inner')}>
              <div className={getClassName(options, 'container_classname', '')}>
                {props.items.map(item => {
                  return (
                    <div
                      key={options.key && item && item.key ? `${options.key}-${item.key}` : ''}
                      className={getClassName(options, 'item_classname', '')}
                    >
                      <h3 className={getClassName(options, 'item_title_classname', '')}>{item.title}</h3>
                      <p className={getClassName(options, 'item_subtitle_classname', '')}>{item.subtitle}</p>
                    </div>
                  )
                })}
              </div>
            </div>
          </section>
        </>
      )
    })
}
